import { render, staticRenderFns } from "./BranchSummary.vue?vue&type=template&id=16307e94"
import script from "./BranchSummary.vue?vue&type=script&lang=js"
export * from "./BranchSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports